"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandArrowsIcon = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const ExpandArrowsIcon = (_a) => {
    var { stroke = ui_components_1.baseColors.primaryGreen300 } = _a, props = __rest(_a, ["stroke"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { d: "M5 15L11.2191 20.3306C11.6684 20.7158 12.3316 20.7158 12.7809 20.3306L19 15", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }), react_1.default.createElement("path", { d: "M5 9L11.2191 3.66939C11.6684 3.2842 12.3316 3.2842 12.7809 3.66939L19 9", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" })));
};
exports.ExpandArrowsIcon = ExpandArrowsIcon;
exports.default = exports.ExpandArrowsIcon;
